export default __webpack_public_path__ + "19ba47063fd12faaa9900b73e478ccc5.jpg";